<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items"/>
        <b-card>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="name">Name</label>
                <input v-model="search_data.name" type="text" class="form-control form-control-sm" placeholder="Search by name" id="name"/>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="award_book_type_id">Award Book Type</label>
                <select v-model="search_data.award_book_type_id" class="form-control form-control-sm" name="award_book_type_id" id="award_book_type_id">
                  <option selected :value="''">Select a Award Book Type</option>
                  <option v-for="(award_book_type, index) in award_book_types" :key="index" :value="award_book_type.id">{{award_book_type.id}} : {{ award_book_type.award_book_type_desc }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="book_no">Book No</label>
                <input v-model="search_data.book_no" type="text" class="form-control form-control-sm" placeholder="Search by book no." id="book_no"/>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="field_book_no">Field Book No.</label>
                <input v-model="search_data.field_book_no" type="text" class="form-control form-control-sm" placeholder="Search by field book no." id="field_book_no"/>
              </div>
            </div>
            <div class="form-row mt-1">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="mouza_id">Mouza</label>
                <select v-model="search_data.mouza_id"  id="mouza_id" name="mouza_id" class="form-control form-control-sm">
                  <option :value="''" selected>Select Mouza</option>
                  <option v-for="(mouza, index) in mouzas" v-bind:value="mouza.id" :key="index">{{ mouza.id }} : {{ mouza.mouza_desc }}</option>
                </select>
              </div>
            </div>
            <button class="btn btn-success btn-sm mt-2" @click.prevent="search">Search</button>

          </form>
        </b-card>

        <b-card>
          <b-button v-if="userPermission.includes('award-book-create')" v-b-modal.award-book-modal type="button"
                    @click="$bvModal.show('award-book-modal'),resetForm()" class="btn btn-success float-right btn-sm mb-1 text-black float-right">
            <i class="mdi mdi-plus-box-outline"></i> Add Award Book
          </b-button>

          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Name</th>
                <th>Father`s Name</th>
                <th>Total Land</th>
                <th>Amount</th>
                <th>Book No.</th>
                <th>Award Book Type</th>
                <th>Award Book E Type</th>
                <th>Field Book No.</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(award_book, index) in award_books.data" :key="index">
                <td>{{ award_books.from + index }}</td>
                <td>{{ award_book.name }}</td>
                <td>{{ award_book.fathers_name }}</td>
                <td>{{ award_book.total_land }}</td>
                <td>{{ award_book.amount }}</td>
                <td>{{ award_book.book_no }}</td>
                <td>{{ award_book.award_book_type ? award_book.award_book_type.award_book_type_desc : ''}} </td>
                <td>{{ award_book.award_book_e_type ? award_book.award_book_e_type.award_book_e_type_desc : '' }}</td>
                <td>{{ award_book.field_book_no }}</td>
                <td>
                  <a v-if="userPermission.includes('award-book-update')" href="javascript:void(0);"
                     class="action-icon" title="Update Award Book" @click="updateAwardBook(award_book.id)">
                    <i class="mdi mdi-square-edit-outline editButton"></i>
                  </a>
                  <a v-if="userPermission.includes('award-book-delete')" href="javascript:void(0);"
                     class="action-icon" title="Delete Award Book" @click="onDelete(award_book.id, index)">
                    <i class="mdi mdi-delete deleteButton"></i>
                  </a>
                  <a href="javascript:void(0);"
                     class="action-icon" title="View Award Book" @click="viewAwardBook(award_book)">
                    <i class="mdi mdi-account-card-details viewColor"></i>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="loader" class="loader">Loading...</div>
            <h5 class="text-center text-secondary" v-if="award_books.total === 0 || !flag">
              No Data Found
            </h5>
            <div class="float-right mt-1">
              <pagination :data="award_books" :limit="2" @pagination-change-page="getResults"></pagination>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <view-award-book-modal
        :award_book="award_book"
    ></view-award-book-modal>
    <award-book-modal
        @search="search"
        :award_book="award_book"
        :btn_edit="btn_edit"
        @resetForm="resetForm"
        ref="awardBookModal"
    ></award-book-modal>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config.json";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import viewAwardBookModal from './modal/viewAwardBookModal'
import awardBookModal from './modal/awardBookModal'

export default {
  page: {
    title: "List of Award Book",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, viewAwardBookModal, awardBookModal},
  data() {
    return {
      title: "List of Award Book",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "List of Award Book",
          active: true
        }
      ],
      search_data: {
        name: '',
        award_book_type_id: '',
        field_book_no: '',
        mouza_id: '',
        book_no: '',
      },
      award_book_types: [],
      mouzas: [],
      award_books: {},
      flag: false,
      loader: false,
      btn_edit: false,
      award_book: {},
    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    getCodes() {
      http.get("api/award-book/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.award_book_types = data.award_book_types;
          this.mouzas = data.mouzas;
        }
      });
    },
    search() {
      this.flag = true
      this.loader = true
      http.post("api/award-book/search", this.search_data).then(response => {
        if (!response.error) {
          this.flag = true;
          this.loader = false
          this.award_books = response.data.award_books;
        }
      });
    },
    getResults(page = 1) {
      this.flag = true
      this.loader = true
      http.post('api/award-book/search?page=' + page, this.search_data)
          .then(response => {
            this.flag = true;
            this.loader = false
            this.award_books = response.data.award_books;
          });
    },
    onDelete(id, index) {
      if (confirm("Do you really want to delete?")) {
        http.delete("api/award-books/" + id).then(response => {
          this.search();
          this.$bvToast.toast(response.data.message, {
            title: "Success",
            autoHideDelay: 5000,
            variant: "success"
          });
        });
      }
    },
    viewAwardBook(award_book){
      this.award_book = {};
      this.award_book = award_book;
      this.$root.$emit("bv::show::modal", "award-book-view-modal");
    },
    async updateAwardBook(award_book_id){
      this.award_book = {};
      this.btn_edit = true;
      await http.get("api/award-books/" + award_book_id +  "/edit" ).then(response => {
        this.award_book = response.data.award_book;
        let mouza_id = response.data.award_book.mouza_id;
        //this.$refs.awardBookModal.getPlotSchedule(mouza_id);
        this.$root.$emit("bv::show::modal", "award-book-modal");
      });
    },
    resetForm() {
      this.btn_edit = false;
      this.award_book = {};
    },
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    },
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
<style src="vue-select/dist/vue-select.css"></style>
